import { render, staticRenderFns } from "./ControversyAdditionalInfo.vue?vue&type=template&id=5381fb4c&scoped=true"
import script from "./ControversyAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./ControversyAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./ControversyAdditionalInfo.vue?vue&type=style&index=0&id=5381fb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381fb4c",
  null
  
)

export default component.exports